import dataApi from "./data";

const api = {
  dataApi,
};

export function useApi() { 
  return api;
}

export default useApi;